import './onboarding-progress.css';

/** Design item 38: a labelled progress bar with the figures as text, so state is never conveyed by colour alone. */
export function OnboardingProgress({completed,total,label,unit='tasks'}:{completed:number|null|undefined;total:number|null|undefined;label:string;unit?:string}){
  if(typeof completed!=='number'||typeof total!=='number'||total<=0)return <span className="onboarding-progress__text">Progress unavailable</span>;
  const done=Math.min(completed,total);
  return <span className="onboarding-progress"><progress max={total} value={done} aria-label={label}/><span className="onboarding-progress__text">{done} of {total} {unit}</span></span>;
}
